import {
    AbstractControl,
    ValidationErrors,
    ValidatorFn
} from '@angular/forms';

export class SalaryValidationUtils {

    static readonly MAX_SALARY = 999999999;

    static salaryValidator(): ValidatorFn {

        return (
            control: AbstractControl
        ): ValidationErrors | null => {

            const value = control.value;

            if (
                value === null ||
                value === undefined ||
                value === ''
            ) {
                return null;
            }

            if (!isNaN(value)) {
                const salary = Number(value);
                if (salary <= 0) {
                    return { invalidSalary: true };
                }
                if (salary > this.MAX_SALARY) {
                    return { invalidSalary: true };
                }
            }

            return null;
        };
    }

    static getSalaryError(
        control: AbstractControl | null
    ): string {

        if (
            !control ||
            !control.errors ||
            !control.touched
        ) {
            return '';
        }

        if (control.errors['required']) {
            return 'Salary is required.';
        }

        if (control.errors['invalidSalary']) {
            return 'Please enter a valid Salary amount.';
        }

        if (control.errors['minExceedsMax']) {
            return 'Min Salary cannot be greater than Max Salary.';
        }

        return '';
    }
}